<template>
  <button :class="classes"
          :disabled="ui.instance.processing"
          @click="createInstance">
    <template v-if="ui.instance.saving">
      <loading-spinner size="1x"></loading-spinner>
    </template>
    <template v-else>
      <slot>Start now</slot>
    </template>
  </button>
</template>
<script>
import { saveInstance as saveThreeSixtyInstance } from "~/Scripts/resources/threeSixtyResource";
import { saveInstance as savePersonaInstance } from "~/Scripts/resources/personaResource";
import { saveInstance as saveStyleInstance } from "~/Scripts/resources/styleResource";

import { INSTANCE_TYPE } from "~/Components/constants";

export default {
  name: "InstanceCreator",
  props: {
    classes: {
      type: String,
      default: "cta cta--primary--alt",
    },
    instanceType: {
      type: String,
      required: true,
      // eslint-disable-next-line
      validator(val) {
        return [
          INSTANCE_TYPE.THREE_SIXTY,
          INSTANCE_TYPE.PERSONA,
          INSTANCE_TYPE.STYLE,
          INSTANCE_TYPE.SURVEY,
          INSTANCE_TYPE.ENGAGE,
          INSTANCE_TYPE.TEAM,
        ].includes( val.toUpperCase() );
      },
    },
  },
  data: () => ( {
    INSTANCE_TYPE,
    ui: {
      instance: {
        processing: false,
        saving: false,
        error: false,
        errorMessage: null,
      },
    },
  } ),
  computed: {
    instanceName () {
      const formattedDate = this.getFormattedDate();

      switch ( this.instanceType ) {
        case this.INSTANCE_TYPE.THREE_SIXTY:
          return `LM 360 ${formattedDate}`;
        case this.INSTANCE_TYPE.PERSONA:
          return `LM Persona ${formattedDate}`;
        case this.INSTANCE_TYPE.STYLE:
          return `LM Style ${formattedDate}`;
        default:
          throw new Error( "instanceType is not valid." );
      }
    },
    saveInstance () {
      switch ( this.instanceType ) {
        case this.INSTANCE_TYPE.THREE_SIXTY:
          return this.submitThreeSixtyInstance;
        case this.INSTANCE_TYPE.PERSONA:
          return this.submitPersonaInstance;
        case this.INSTANCE_TYPE.STYLE:
          return this.submitStyleInstance;
        default:
          throw new Error( "saveInstance is not defined." );
      }
    },
  },
  methods: {
    createInstance () {
      this.ui.instance.processing = true;
      this.ui.instance.saving = true;
      this.$emit( "saving", true );

      this.saveInstance()
        .then( instanceId => {
          this.$emit( "success", instanceId );
        } )
        .catch( err => {
          console.error( err );
          this.makeToast(
            "An error has occured.",
            "We were unable to create your instance. Please, try again or contact us.",
            "danger",
          );
          this.ui.instance.processing = false;
        } )
        .finally( () => {
          this.ui.instance.saving = false;
          this.$emit( "saving", false );
        } );
    },
    isNullOrEmpty ( val ) {
      return val == null || val === "";
    },
    getFormattedDate () {
      const now = new Date();

      const day = now.getDate();
      const month = now.getMonth() + 1;
      const year = now.getFullYear();
      const hour = now.getHours();
      const minute = now.getMinutes();

      const minuteWithLeadingZero = ( minute < 10 ? "0" : "" ) + minute;

      return `${day}/${month}/${year} ${hour}:${minuteWithLeadingZero}`;
    },
    makeToast ( title, body, variant = null ) {
      this.$bvToast.toast( body, {
        title,
        variant,
        solid: true,
      } );
    },
    submitThreeSixtyInstance () {
      return new Promise( ( resolve, reject ) => {
        const payload = {
          instanceId: null,
          instanceName: this.instanceName,
          dateSubmitted: null,
          pathwayItemId: null,
        };

        saveThreeSixtyInstance( payload )
          .then( response => {
            const { status, data: instanceId } = response;

            if ( status === 200 && this.isNullOrEmpty( instanceId ) === false ) {
              resolve( instanceId );
            } else {
              throw new Error( "Instance failed to be created" );
            }
          } )
          .catch( err => {
            console.error( err );
            reject( err );
          } );
      } );
    },
    submitPersonaInstance () {
      return new Promise( ( resolve, reject ) => {
        const payload = {
          instanceId: null,
          instanceName: this.instanceName,
          pathwayItemId: null,
        };

        savePersonaInstance( payload )
          .then( response => {
            const { status, data: instanceId } = response;

            if ( status === 200 && this.isNullOrEmpty( instanceId ) === false ) {
              resolve( instanceId );
            } else {
              throw new Error( "Instance failed to be created" );
            }
          } )
          .catch( err => {
            console.error( err );
            reject( err );
          } );
      } );
    },
    submitStyleInstance () {
      return new Promise( ( resolve, reject ) => {
        const payload = {
          instanceId: null,
          instanceName: this.instanceName,
          pathwayItemId: null,
        };

        saveStyleInstance( payload )
          .then( response => {
            const { status, data: instanceId } = response;

            if ( status === 200 && this.isNullOrEmpty( instanceId ) === false ) {
              resolve( instanceId );
            } else {
              throw new Error( "Instance failed to be created" );
            }
          } )
          .catch( err => {
            console.error( err );
            reject( err );
          } );
      } );
    },
  },
};
</script>
<style lang="less" scoped></style>
